import styled from 'styled-components';
import { Accordion as BaseAccordion, AccordionProps } from '@mui/material';

const Accordion = styled(BaseAccordion)<AccordionProps>`
  box-shadow: none;

  &:before {
    display: none;
  }
`;

Accordion.defaultProps = {
  disableGutters: true,
  TransitionProps: { timeout: 300 },
};

export default Accordion;
